module.exports = __webpack_public_path__ + "img/Icon ionic-ios-time.90f57ed0.svg";